import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { crearAnexo } from "../../services/anexos-service";
import { selectSoftware } from "../../services/software-service";

const FormAnexos = ({ modalState, onSave }) => {
    const [software, setSoftware] = useState([]);

    useEffect(async () => {
        const resp = await selectSoftware();
        if (!resp.status) return toast.error(resp.message);

        setSoftware(
            resp.data.map((software) => {
                return {
                    label: software.nombre,
                    value: software.id,
                };
            })
        );
    }, []);

    const form = useForm();

    const onCreateAnexo = async () => {
        const anexo = new FormData(document.getElementById("formAnexos"));
        const resp = await crearAnexo(anexo);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formAnexos"
            isOpen={modalState.show}
            onSubmit={onCreateAnexo}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="software_id"
                        label="Software"
                        control={form.control}
                        options={software}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="file"
                        multiple
                        label="Flujograma"
                        errors={form.formState.errors}
                        control={form.control}
                        name="flujograma[]"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <InputController
                        type="file"
                        multiple
                        label="UML"
                        errors={form.formState.errors}
                        control={form.control}
                        name="uml[]"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="file"
                        multiple
                        label="Prototipo"
                        errors={form.formState.errors}
                        control={form.control}
                        name="prototipo[]"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAnexos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormAnexos;
